import styled from 'styled-components';
import Button from 'products/nomad_insurance/components/Button';
import Feedback from 'products/nomad_insurance/components/Feedback';
import { InfoText } from '../../../../styled';

export const InsuranceProviderText = styled(InfoText)`
  margin-top: 24px;
`;

export const StyledButton = styled(Button)`
  padding: 9px 60px;
`;

export const RecurringInfo = styled(Feedback)`
  margin-top: 24px;
`;
